import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router';

import {
    ClipsPageContainer,
    HomePageContainer,
    LoginPageContainer,
    SearchResultsContainer,
    TranscriptContainer,
    UploadPageContainer,
} from './pages';
import { RootState } from './types';

interface IProps {
    isSignedIn: boolean,
}

export default class AppBody extends React.Component<IProps> {

    private routes = {
      clips: () => (<ClipsPageContainer />),
      home: () => <HomePageContainer />,
      login: () => (<LoginPageContainer />),
      search: () => (<SearchResultsContainer />),
      transcript: ({match}: RouteComponentProps<{trackID: string}>) => (<TranscriptContainer trackID={match.params.trackID} />),
      upload: () => (<UploadPageContainer />),
    }
  
    public render() {
      const {routes} = this;
      const {isSignedIn} = this.props;

        if (!isSignedIn) {
            return (<LoginPageContainer />);
        }

      return (<div className="main">
        <Route key="home" exact={true} path="/" render={routes.home} />
        <Route key="search" path="/search" render={routes.search} />
        <Route key="login" path="/login" render={routes.login} />
        <Route key="tracks" path="/tracks/:trackID" render={routes.transcript} />
        <Route key="upload" path="/upload" render={routes.upload} />
        <Route key="clips" path="/clips" render={routes.clips} />
      </div>);
    }
  
}

export const AppBodyContainer = connect(
({clips, auth}: RootState) => ({
    clips: Object.keys(clips.data).map(id => clips.data[id]),
    isSignedIn: auth.currentUser !== null,
}),
)(AppBody);



// WEBPACK FOOTER //
// ./src/AppBody.tsx